@if (!open || minimized) {
  <div class="chat-fab" (click)="abrirChat()">
    <span class="chat-fab-icon">
      <img
        src="assets/images/aire_widget.png"
        alt="chat"
        class="chat-fab-image"
      />
    </span>
  </div>
}

@if (open) {
  <div
    class="chat-container"
    [ngStyle]="{
      left: chatPosX + 'px',
      top: chatPosY + 'px',
      width: chatWidth + 'px',
      height: chatHeight + 'px',
      position: 'fixed',
    }"
    [class.minimized]="minimized"
  >
    <div class="chat-header" (mousedown)="onHeaderMouseDown($event)">
      <!-- Cabecera del chat -->
      <span class="chat-title">{{ "chatbot.title" | translate }}</span>
      <!-- ...botones de minimizar/cerrar... -->
      <div>
        <button
          type="button"
          (click)="minimizarChat()"
          class="buttonChat"
          style="margin-right: 0.5rem"
          title="Minimizar chat"
          aria-label="Minimizar chat"
        >
          <span class="pi pi-window-minimize"></span>
        </button>
        <button
          type="button"
          (click)="cerrarChat()"
          class="buttonChat"
          title="Cerrar chat"
          aria-label="Cerrar chat"
        >
          <span class="pi pi-times"></span>
        </button>
      </div>
    </div>
    <!-- Handlers de redimensión -->
    <div
      class="resize-handler top"
      (mousedown)="onResizeMouseDown($event, 'top')"
    ></div>
    <div
      class="resize-handler right"
      (mousedown)="onResizeMouseDown($event, 'right')"
    ></div>
    <div
      class="resize-handler bottom"
      (mousedown)="onResizeMouseDown($event, 'bottom')"
    ></div>
    <div
      class="resize-handler left"
      (mousedown)="onResizeMouseDown($event, 'left')"
    ></div>
    <div
      class="resize-handler top-left"
      (mousedown)="onResizeMouseDown($event, 'top-left')"
    ></div>
    <div
      class="resize-handler top-right"
      (mousedown)="onResizeMouseDown($event, 'top-right')"
    ></div>
    <div
      class="resize-handler bottom-left"
      (mousedown)="onResizeMouseDown($event, 'bottom-left')"
    ></div>
    <div
      class="resize-handler bottom-right"
      (mousedown)="onResizeMouseDown($event, 'bottom-right')"
    ></div>
    <!-- ...contenido del chat... -->
    <div #webchat class="webchat-container"></div>
  </div>
}
